import React from 'react';

import StyledComponent from '~/components/Styled/Styled';
import css from './NewsletterCard.scss';

interface Props {
  message: string;
  subscribe(email: string): void;
}

class NewsletterCard extends React.Component<Props> {
  static displayName = 'NewsletterCard';

  handleKeyDown = event => {
    // On Enter submit
    if (event.keyCode === 13) {
      this.handleSubmit();
    }
  };

  handleSubmit = () => {
    this.props.subscribe(this.textInput.current.value);
  };

  textInput: React.RefObject<HTMLInputElement> = React.createRef();

  render() {
    const { message } = this.props;
    return (
      <div>
        <div className={css.newsletterContainer}>
          <h2 className={css.newsletterHeader}>
            <div className={css.emailIcon} />
            Daily Newsletter
          </h2>
          <div className={css.title}>Get the latest trending sports news daily in your inbox</div>
          <input
            ref={this.textInput}
            className={css.emailInput}
            placeholder="Enter your email"
            maxLength={254}
            type="email"
            onKeyDown={this.handleKeyDown}
            aria-describedby="subscribe-message"
            id="email"
          />
          <label htmlFor="email" className={css.srOnly}>
            Email address
          </label>
          <button className={css.subscribe} onClick={this.handleSubmit}>
            Subscribe
          </button>
          <div id="subscribe-message" className={css.message}>
            {message}
          </div>
        </div>
      </div>
    );
  }
}

export default StyledComponent(NewsletterCard, [css]);
